import { observer } from 'mobx-react-lite';
import CustomDropdown from '../../Globle/CustomDropdown';
import { ScopOptions } from '../../../__utils/UiConst';
import { ProjectScope } from '../../../config';
import Button from '../../Globle/Button';

const ProjectDetails = observer(
    ({ Form, form, isStyleTabDisabled, onNext }) => {
        const selectedProjectScope = Form.useWatch('projectScope', form);
        return (
            <div className="collapse-content relative h-[calc(100dvh-150px)]">
                <h1 className="text-[32px] font-favorit font-[700] leading-[40px] pb-[24px]">
                    Add project details
                </h1>
                <Form.Item
                    name="projectName"
                    label={'Project Name *'}
                    preserve={true}
                    className="custom-form-item"
                    rules={[
                        { required: true, message: 'Project Name is required' },
                    ]}>
                    <input
                        maxLength={35}
                        className="custom-form-input mt-2 w-full"
                        placeholder="Project Name"
                    />
                </Form.Item>
                <Form.Item
                    name="projectDescription"
                    label={'Project Description'}
                    className="custom-form-item"
                    maxLength={500}
                    rules={[]}>
                    <textarea
                        maxLength={500}
                        className="custom-form-input mt-2 w-full !h-auto"
                        placeholder="Add your description (max 500 characters)"
                        rows={5}
                    />
                </Form.Item>
                <div className="grid grid-cols-2 gap-6">
                    <Form.Item
                        name="projectCreator"
                        label={'Developer *'}
                        className="custom-form-item"
                        rules={[
                            {
                                required: true,
                                message: 'Developer Name is required',
                            },
                        ]}>
                        <input
                            maxLength={35}
                            className="custom-form-input mt-2 w-full capitalize"
                            placeholder="Developer Name"
                        />
                    </Form.Item>
                    <div className="flex gap-[16px]">
                        <Form.Item
                            name="projectScope"
                            label="Scope *"
                            className={`custom-form-item ${selectedProjectScope === ProjectScope.CUSTOM ? 'w-1/2' : 'w-full'}`}
                            rules={[
                                {
                                    required: true,
                                    message: 'Scope is required',
                                },
                            ]}>
                            <CustomDropdown
                                className="mt-2"
                                rootClassName="h-[48px]"
                                popupClassName="!h-[150px]"
                                placeholder="Select Scope"
                                options={ScopOptions}
                                value={selectedProjectScope}
                                onChange={(value) => {
                                    form.setFieldValue('projectScope', value);
                                    if (value === 'Custom') {
                                        form.setFieldValue('customScope', '');
                                    } else {
                                        form.setFieldValue(
                                            'customScope',
                                            undefined,
                                        );
                                    }
                                }}
                            />
                        </Form.Item>

                        {selectedProjectScope === ProjectScope.CUSTOM && (
                            <Form.Item
                                name="customScope"
                                label="Custom Scope *"
                                className="custom-form-item w-1/2"
                                rules={[
                                    {
                                        required: true,
                                        message: 'Custom Scope is required',
                                    },
                                ]}>
                                <input
                                    className="custom-form-input mt-2 w-full"
                                    placeholder="Custom Scope"
                                />
                            </Form.Item>
                        )}
                    </div>
                </div>
                <Button
                    type="button"
                    onClick={onNext}
                    label={'Next Step'}
                    className={`absolute bottom-[16px] right-[0px] ${isStyleTabDisabled ? 'pointer-events-none !bg-[#F5F5F5] !text-[#CCCCCC]' : 'bg-theme-orange text-theme-white hover:bg-theme-orange-hover'}`}
                />
            </div>
        );
    },
);

export default ProjectDetails;
